<template>
  <div style="width: 100%;" class="custom-container">
    <v-row dense no-gutters>
      <v-col cols="12">
        <Table
          :key="tableKey"
          :items="libraries"
          :loading="loading"
          @activeOnly="activeOnlyFunction($event)"
          @changeStatus="changeStatus($event)"
          @fetchLibraries="fetchLibraries($event)"
          @copyCreate="copyCreate($event)"
        ></Table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Table from './LibrariesDatatable'
import {
  getLibrariesUsingGET as getLibraries,
  disableLibraryUsingGET as disableLibrary,
  enableLibraryUsingGET as enableLibrary
} from '@/utils/api'
import { mapActions } from 'vuex'

export default {
  components: {
    Table
  },
  data() {
    return {
      err: '',
      success: '',
      activeOnly: true,
      tableKey: 0,
      loading: false,
      libraries: { items: [], meta: {} }
    }
  },
  computed: {},
  created() {
    if (this.$route.params && this.$route.params.message) {
      this.addSnackbar({
        message: this.$route.params.message,
        timeout: 5000,
        color: 'success'
      })

    }
  },
  methods: {
    ...mapActions('app', ['addSnackbar']),

    copyCreate(item) {
      const tempItem = item

      delete tempItem.id
      delete tempItem.createdOn
      delete tempItem.modifiedOn
      delete tempItem.roles

      tempItem.name = `${item.name} - Copy - ${this.$options.filters.formatDateTime(new Date())}`

      this.$router.push({ name: 'libraryCreate', params: { copy: tempItem } })
    },
    activeOnlyFunction(event) {
      this.activeOnly = event.activeOnly

      this.fetchLibraries(event.options)
    },
    fetchLibraries(options) {
      this.loading = true

      const obj = {}

      if (options) {
        if (options.options && options.options.itemsPerPage !== -1) {
          obj.page = options.resetPage ? 1 : options.options.page || 1
          obj.size = options.options.itemsPerPage || 25
        } else {
          obj.page = 1
          obj.size = 25
        }
      } else {
        obj.page = 1
        obj.size = 25
      }

      if (options?.options?.sortDesc && options.options.sortDesc.length > 0) obj.orderDirection = options.options.sortDesc[0] ? 'DESC' : 'ASC'

      if (options && options.options && options.options.sortBy && options.options.sortBy.length > 0) {
        obj.orderField = options.options.sortBy[0]
      }

      if (options && options.search && options.search.length > 1) {
        obj.name = options.search
      }

      if (options && options.type) {
        obj.type = options.type
      }

      if (options && options.permissionType) {
        obj.permissionType = options.permissionType
      }

      if (this.activeOnly) obj.status = 'ACTIVE'

      getLibraries(obj)
        .then((res) => {
          this.libraries = res.data.data
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          console.log(error)
        })
    },
    async changeStatus (item) {
      try {
        const res = item.status === 'ACTIVE' ? await disableLibrary({ id: item.id }) : await enableLibrary({ id: item.id })

        if (res.status !== 200) {
          this.addSnackbar({
            message: this.$lang.errors.libraryStatusUpdate,
            timeout: 5000,
            color: 'error'
          })

          return
        }
        const successMessage = item.status !== 'ACTIVE' ? this.$lang.success.libraryActivated : this.$lang.success.libraryDeactivated

        this.addSnackbar({
          message: successMessage,
          timeout: 5000,
          color: 'success'
        })
        const changedItem = this.libraries.items.find((x) => x.id === item.id)

        if (changedItem) this.libraries.items.find((x) => x.id === item.id).status = res.data.data.status

      } catch (err) {
        this.addSnackbar({
          message: err,
          timeout: 5000,
          color: 'error'
        })
      }
    }
  }
}
</script>
